import env from '@beam-australia/react-env';

export default {
  LEGACY_DODDLE_API_URL: env('LEGACY_DODDLE_API_URL'),
  DODDLE_API_URL: env('DODDLE_API_URL'),
  LOQATE_API_URL: env('LOQATE_API_URL'),
};
